<template>
    <page title="competitionApprovalDetailView" v-if="Competition" :textHeight="(WindowSize.y - 276) + 'px'">
        <template #pageContainer>
				<v-row>
					<v-col cols="12" sm="3" lg="3"><b>{{ $t(`text.createdOn`) }}:</b></v-col>
					<v-col cols="12" sm="3" lg="3">{{ Competition.createdAt | moment('DD.MM.YYYY') }}</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="3" lg="3"><b>{{ $t(`text.createdFrom`) }}:</b></v-col>
					<v-col cols="12" sm="3" lg="3">{{ Competition.createdByUsername }}</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="3" lg="3"><b>{{ $t(`text.lastEditedOn`) }}:</b></v-col>
					<v-col cols="12" sm="3" lg="3"><template v-if="!!Competition.changedAt">{{ Competition.changedAt | moment('DD.MM.YYYY') }}</template></v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="3" lg="3"><b>{{ $t(`text.editedFrom`) }}:</b></v-col>
					<v-col cols="12" sm="3" lg="3"><template v-if="!!Competition.changedByUsername">{{ Competition.changedByUsername }}</template></v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="3" lg="3"><b>{{ $t(`text.status`) }}:</b>
						<v-menu open-on-hover top offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
								v-bind="attrs"
								v-on="on">info</v-icon>
							</template>

							<v-list>
							<v-list-item
								v-for="(item, index) in approvalState"
								:key="index">
								<v-list-item-title><v-icon :color="item.color">mdi-checkbox-blank-circle</v-icon>{{ item.text }}</v-list-item-title>
							</v-list-item>
							</v-list>
						</v-menu>
					</v-col>
					<v-col cols="12" sm="9" lg="9">
						<v-row v-for="(a, i) in Competition.approvals" :key="i + '-ap'">
							<v-col>
								<v-icon :color="getStatusColor(a.approvalState)">mdi-checkbox-blank-circle</v-icon>{{ a.organization }} <span v-if="a.changedAt">({{a.changedAt | moment('DD.MM.YYYY')}})</span><br>
								<p v-if="a.reason"><b>{{ $t(`text.headerReason`) }}:</b> {{a.reason}}</p>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" sm="3" lg="3"><b>{{ $t(`text.invoiceDate`) }}:</b></v-col>
					<v-col cols="12" sm="3" lg="3">{{ Competition.receipt_At | moment('DD.MM.YYYY') }}</v-col>
				</v-row>
            <spinner :loading="loading"></spinner>
        </template>
		<template #pageActions>
			<v-row>
				<v-col>
				<v-btn
                    class="mr-4"
                    @click="backToOverview">
                    {{ $t(`text.backToOverview`) }}
                </v-btn>
				<v-btn
					class="mr-4"
					@click="next">
					{{ $t(`text.next`) }}
				</v-btn>
				<v-btn
					class="mr-4"
					@click="back">
					{{ $t(`text.backButton`) }}
				</v-btn>
				</v-col>
			</v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import compApprovalActions from '../store/actions/compApproval';
import namespace from '../store/namespace';

import getApprovalState from '../models/approvalState';

import Page from '../general/Page.vue';
import Spinner from '../general/Spinner.vue';

export default {
	name: 'CompetitionApprovalDetailView',
	components: {
		Page,
		Spinner,
	},
	data() {
		return {
			loading: false,
		};
	},
	async mounted() {
		this.loading = true;
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}
		const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
		if (link) {
			await this.GET_COMP_BY_ID({ link, cGuid: this.cGuid });
		}
		this.loading = false;
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competition']),
		cGuid() {
			return this.$route.params.cGuid || null;
		},
		approvalState() {
			return getApprovalState(this).filter(x => x.value !== null);
		},
		getStatusColor: state => id => (state.approvalState.find(x => x.value === id)).color,
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.GET_COMP_BY_ID,
		]),
		next() {
			if (this.$route.name === 'compFinisherDetailView') {
				this.$router.push({
					name: 'compFinisherAttachments',
					params: { cGuid: this.cGuid },
				});
			} else {
				this.$router.push({
					name: 'showcompetitionapproval',
					params: { cGuid: this.cGuid },
				});
			}
		},
		backToOverview() {
			this.$router.push({
				name: 'competitionapproval',
			});
		},
		back() {
			this.$router.go(-1);
		},
	},
};
</script>
